import { PageAPI } from './api/index.ts';

export const page = PageAPI.getInstance();
